import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { isEmpty } from '../../helpers';
import { StyledFieldLabel, StyledTextField } from './styled';

type PropsType = {
  disabled: boolean;
  value: string;
  onChange: (value: string) => void;
  onValidationChange: (isValid: boolean) => void;
};

const MAX_LENGTH = 100;

const NameField = ({
  disabled,
  value,
  onChange,
  onValidationChange,
}: PropsType) => {
  const [error, setError] = useState<Error | null>(null);

  const validateName = (name: string) => {
    const trimmedName = name.trim();
    if (trimmedName.length > MAX_LENGTH) {
      setError(Error(`Name cannot exceed ${MAX_LENGTH} characters`));
    } else {
      setError(null);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    onChange(newValue);
    validateName(newValue);
  };

  useEffect(() => {
    onValidationChange(!error && !isEmpty(value));
  }, [error, value, onValidationChange]);

  return (
    <Box>
      <StyledFieldLabel>Name</StyledFieldLabel>
      <StyledTextField
        placeholder="Name"
        value={value}
        disabled={disabled}
        variant="outlined"
        error={!!error}
        helperText={error && error.message}
        onChange={handleChange}
      />
    </Box>
  );
};

export default NameField;
